import { atom, useAtom } from "jotai";
import { DateToyyyymmdd } from "../../../../_helper/utils/utils";

export const sendDttoprint = atom(false);
export const SendPrevConsultationData = atom();
export const NullPrevConsultationdata = atom(false);
export const PreviousConsultationDataPatchPost = atom();
export const isPatchAtom = atom(false);
export const OpenFormPreview = atom(false);
export const OpenAddAdvice = atom(false);
export const GetAdvices = atom();

//for set price
export const BillPrice = atom(0);
export const billAtom = atom({
  status: "Pending",
  total: 0,
  patient_user: null,
  actual_price: [],
});

//end for set price

export const openShareBtnModal = atom(false);
